import { select, put } from 'redux-saga/effects';
import { isUserReadyToGetNewEvent } from '../../../reducers/domain/centrifugo/personal';
import { setPersonalInfo } from '../../../actions/domain/centrifugo/personal';

export function* personalHandler(data: unknown) {
  const isReady: ReturnType<typeof isUserReadyToGetNewEvent> = yield select(
    isUserReadyToGetNewEvent
  );
  if (isReady) {
    yield put(setPersonalInfo(data));
  }
}
